import { FC } from 'react';

import { Check, Tag } from 'lucide-react';

import { AnalyticsCardsRow } from '../../../../components/shared/AnalyticsCardsRow';
import { OfferType } from '../../../../types';

interface Props {
    counts: Record<OfferType, number>;
}

export const AnalyticsRow: FC<Props> = ({ counts }) => {
    return (
        <AnalyticsCardsRow
            items={[
                {
                    label: 'Всього пропозицій',
                    value: counts.all,
                    icon: Tag,
                    iconWrapperClassName: 'bg-primary/10',
                    iconClassName: 'text-primary',
                },
                {
                    label: 'Активні',
                    value: counts.active,
                    icon: Check,
                    iconWrapperClassName: 'bg-green-500/10',
                    iconClassName: 'text-green-500',
                },
            ]}
        />
    );
};
